import { Entity } from "./types";

type CharacterName = "Lawyer" | 
  "Cooper" | 
  "Cherry" | 
  "Grace" |
  "Bjork" | 
  "James" | 
  "JamesGuyFierie" | 
  "Gordon" | 
  "BigEd" | 
  "James" | 
  "Donna" | 
  "Bob" | 
  "Mandelbrot" | 
  "Pie" | 
  "TheProgenator"|
  "HawaiianShirtGuy"|
  "Chud"|
  "Wax"|
  "Griselda"


const characters: {[key in CharacterName]: Entity} = {

 Lawyer: {
    name: "Lawyer",
    image: "https://justatic.com/profile-images/1492708-1664285635-s.jpeg"
  },

  Cooper: {
    name: "Cooper",
    image: "/resources/cooper.jpeg"
  },

  Cherry: {
    name: "Cherry", 
    image: "/resources/pie.jpeg"
  },

  Grace: {
    name: "Grace",
    image: "https://mir-s3-cdn-cf.behance.net/projects/404/aa5ff872481717.5be95761be97a.jpg"
  },

  Bjork: {
    name: "Bjork",
    image: "https://static.dw.com/image/41478168_702.jpg"
  },
  JamesGuyFierie: {
    name:  "James Guy Fierie",
    image: "https://retouchingcentral.com/wp-content/uploads/2019/03/matrix-10.gif",
  },

  Gordon: {
    name: "Gordon", 
    image: "/resources/gordon.jpeg"
  },

  BigEd: {
    name: "Big Ed",
    image: "https://twinpeaksfreaks.files.wordpress.com/2014/06/ed2.jpg"
  },

  James: {
    name: "James", 
    image: "/resources/james.jpeg"
  },

  Donna: {
    name: "Donna", 
    image: "/resources/donna.webp"
  },

  Bob: {
    name: "Bob", 
    image: "/resources/bob.webp"
  },

  Mandelbrot: {
    name: "Benoit Mandelbrot", 
    image: "/resources/mandelbrot.webp"
  },
  Pie: {
    name: "Cherry", 
    image: "/resources/pie.jpeg"
}, 
  TheProgenator: {
    name: "The Progenator",
    image: "https://cdna.artstation.com/p/assets/images/images/022/422/704/large/davide-rinaudo-screenshot013.jpg?1575385497"
  },
  HawaiianShirtGuy: {
    name: "Hawaiian Shirt Guy",
    image: "https://tropaholic.com/wp-content/uploads/2019/08/Two-Palms-Love-Shack-Red-Model.jpg"
  },
  Chud: {
    name: "Chud",
    image: "/resources/ppl/chud.png"
  },
  Wax: {
    name: "Wax",
    image: "/resources/ppl/wax.png"
  },
  Griselda: {
    name: "Griselda",
    image: "/resources/ppl/griselda.png"
  }
}

export default characters


